import { render, staticRenderFns } from "./VendorHome.vue?vue&type=template&id=6507bbca&scoped=true"
import script from "./VendorHome.vue?vue&type=script&lang=js"
export * from "./VendorHome.vue?vue&type=script&lang=js"
import style0 from "./VendorHome.vue?vue&type=style&index=0&id=6507bbca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6507bbca",
  null
  
)

export default component.exports